// AboutUs.js
import React from "react";
import "../css/ProductsBanner.css";

const ProductsBanner = ({ title = "ABOUT US", backgroundImage, height = "250px" }) => {
  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    height: height,
  };

  return (
    <div className="product-banner" style={containerStyle}>
      <h2 className="about-title">{title}</h2>
    </div>
  );
};

export default ProductsBanner;